import HeaderEnrichment from './Identity/HeaderEnrichment';
import Error from './Shared/Error';
import Success from './Shared/Success';
import Redirect from './Shared/Redirect';
import Spinner from './Shared/Spinner';
import EmptyJavaScriptEvents from './Shared/EmptyJavaScriptEvents';

const ScreenComponents = {  
    HeaderEnrichment: HeaderEnrichment,
    Error: Error,
    Success: Success,
    Redirect: Redirect,
    Spinner: Spinner,
    EmptyJavaScriptEvents: EmptyJavaScriptEvents
};

export default ScreenComponents;


/** WEBPACK FOOTER **
 ** ./src/components/ScreenComponents/index.js
 **/